import { useMemo } from 'react'
import { useAuth } from '@/lib/auth/context'
import { hasPermission, hasAnyPermission, hasAllPermissions, getRolePermissions } from '@/lib/auth/rbac'
import type { Permission, Role } from '@/config/constants'

export function usePermissions() {
  const { user } = useAuth()

  const role = user?.role as Role | undefined

  return useMemo(
    () => ({
      role,
      hasPermission: (permission: Permission) =>
        role ? hasPermission(role, permission) : false,
      hasAnyPermission: (permissions: Permission[]) =>
        role ? hasAnyPermission(role, permissions) : false,
      hasAllPermissions: (permissions: Permission[]) =>
        role ? hasAllPermissions(role, permissions) : false,
      permissions: role ? getRolePermissions(role) : [],
      isOwner: role === 'owner' || role === 'super_admin',
      isSuperAdmin: role === 'super_admin',
      canManageUsers: role ? hasPermission(role, 'USERS_MANAGE') : false,
      canManageConnectors: role ? hasPermission(role, 'CONNECTORS_MANAGE') : false,
      canManageJobs: role ? hasPermission(role, 'JOBS_MANAGE') : false,
      canExportData: role ? hasPermission(role, 'ANALYTICS_EXPORT') : false,
      canManageSettings: role ? hasPermission(role, 'SETTINGS_MANAGE') : false,
    }),
    [role]
  )
}
